import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { defaultSize, sizeMap } from "../buttons/NodeSizeButton/consts.js";
import { ListItemSelect } from "../ListItem/index.js";
import DropdownModal from "./DropdownModal.js";
const SizePanel = ({
  getSelectedSize,
  onClick,
  options: optionsOverride,
  ariaLabeledBy
}) => {
  const { t, jsdomMode } = useContext(RicosContext) || {};
  const options = optionsOverride ? optionsOverride.map((option) => sizeMap[option]) : defaultSize;
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      options: options.map(({ dataHook, icon: Icon, text, commandKey }) => /* @__PURE__ */ React.createElement(
        ListItemSelect,
        {
          key: commandKey,
          dataHook,
          prefix: /* @__PURE__ */ React.createElement(Icon, null),
          title: t(text),
          selected: commandKey === getSelectedSize(),
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              onClick(commandKey);
              e.stopPropagation();
            }
          },
          onClick: () => onClick(commandKey)
        }
      )),
      jsdomMode,
      ariaLabeledBy
    }
  );
};
var SizePanel_default = SizePanel;
export {
  SizePanel_default as default
};
//# sourceMappingURL=SizePanel.js.map
